import React from 'react'
import {AiOutlineArrowUp} from 'react-icons/ai'
import { styled } from 'styled-components'

const BackToTop = () => {
    const handleBacktoTopClick = () => {    
        window.scrollTo({top: 0, behavior: 'smooth'});
    }

  return (
    <Button className='back-to-top' onClick={handleBacktoTopClick}> <AiOutlineArrowUp/> </Button>
  )
}

const Button = styled.button`
    position: fixed;
    bottom: 5em;
    float: right;
    right: 3em;
    background-color: var(--color-white);
    border: none;
    border-radius: 50px;
    padding: 1.2em;
    box-shadow:  0.3em 0.3em 1em rgba(0, 0, 0, 0.3);
    transition: all 0.5s ease-in-out;
    &:hover{
        background-color: var(--primary-color);
        color: white;
    }
    svg{
        font-size: 1.5rem;
    }
`

export default BackToTop